import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog({ open, onClick }) {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Exam Finished</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your exam has finished and we have received your answers. We will be
            in touch with your shortly.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClick}>Click Next</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
